import { Reducer } from 'redux';
import { VideoState, VideosTypes } from './types';

const INITIAL_STATE: VideoState = {
  isLoading: true,
  hasError: false,
  data: [],
  total: 0,
};

const reducer: Reducer<VideoState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VideosTypes.LOAD_VIDEO_LIST_REQUEST:
      return {
        isLoading: true,
        hasError: false,
        data: [],
        total: 0,
      };
    case VideosTypes.LOAD_VIDEO_LIST_SUCCESS:
      return {
        isLoading: false,
        hasError: false,
        data: action.payload.data,
        total: action.payload.total,
      };
    case VideosTypes.LOAD_VIDEO_LIST_FAILURE:
      return {
        isLoading: false,
        hasError: true,
        data: [],
        total: 0,
      };
    default:
      return state;
  }
};

export default reducer;
